/* Wont Miss Garage: behaviour for native sections. Delegated from the document, so it works the same whether a
   section was rendered on its own page or fetched and shown inside the tunnel app. */
(function () {
  if (window.__wmgNativeBound) return;
  window.__wmgNativeBound = true;
  // a button with no link jumps to the brief form on the same page, without touching the address bar
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[data-wmg-to-brief]');
    if (!a) return;
    e.preventDefault();
    var scope = a.closest('[data-native-slot]') || document;
    var form = scope.querySelector('#wmg-brief') || document.getElementById('wmg-brief');
    if (form && form.scrollIntoView) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-wmg-brief]')) return;
    e.preventDefault();
    var msg = form.querySelector('[data-wmg-msg]');
    var btn = form.querySelector('button[type="submit"]');
    var hook = form.getAttribute('data-webhook') || ((window.WMG_SHOP || {}).webhook) || '';
    var payload = { type: 'source_request', page: location.pathname };
    var missing = [];
    form.querySelectorAll('[data-col]').forEach(function (el) {
      var v = String(el.value || '').trim();
      if (el.hasAttribute('required') && !v) missing.push(el.getAttribute('data-label') || el.getAttribute('data-col'));
      if (!v) return;
      var col = el.getAttribute('data-col');
      payload[col] = payload[col] ? payload[col] + '\n' + v : v;
      if (col === 'Name') payload.name = v;
      if (col === 'Email') payload.email = v;
      if (col === 'Phone') payload.phone = v;
    });
    var say = function (text, bad) { if (msg) { msg.textContent = text; msg.className = 'wmgn-form__msg' + (bad ? ' wmgn-form__msg--bad' : ''); } };
    if (missing.length) { say((form.getAttribute('data-missing') || 'Please fill in') + ': ' + missing.join(', '), true); return; }
    if (payload.email && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(payload.email)) { say(form.getAttribute('data-bad-email') || 'That email does not look right', true); return; }
    if (!hook) { say('The form is not connected yet (Theme settings, Google Sheets).', true); return; }
    if (btn) btn.disabled = true;
    say(form.getAttribute('data-sending') || 'Sending\u2026');
    fetch(hook, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify(payload), redirect: 'follow' })
      .then(function () { form.reset(); say(form.getAttribute('data-sent') || 'Brief received'); })
      .catch(function () { say('That did not send. Please try again or email us.', true); })
      .then(function () { if (btn) btn.disabled = false; });
  });
})();

/* ---------- Product grid: "Show all" past the grid's limit ----------
   The rest of the collection, 250 a page, from /collections/<handle>?view=wmgrows, for the theme being viewed. */
(function () {
  function themeUrl(u) {
    try { var th = window.Shopify && window.Shopify.theme; if (th && th.id && th.role && th.role !== 'main') u += (u.indexOf('?') >= 0 ? '&' : '?') + 'preview_theme_id=' + th.id; } catch (e) {}
    return u;
  }
  function esc(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function rowsPage(handle, n) {
    return fetch(themeUrl('/collections/' + encodeURIComponent(handle) + '?view=wmgrows&page=' + n), { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (t) { var a = t.indexOf('/*WMG_ROWS_START*/'), b = t.indexOf('/*WMG_ROWS_END*/'); if (a < 0 || b < a) throw new Error('no rows'); return (new Function('return (' + t.slice(a + 18, b) + ');'))(); });
  }
  function card(r, showPrice, shape) {
    return '<a class="wmgn-card" href="/products/' + esc(r.handle) + '" data-handle="' + esc(r.handle) + '" data-mode="' + esc(r.mode || 'buy') + '" data-name="' + esc(r.name) + '">' +
      (r.img ? '<div class="wmgn-frame" style="--ratio:' + esc(shape) + ';--fit:cover"><img src="' + esc(r.img) + '" loading="lazy" alt="' + esc(r.name) + '"></div>' : '') +
      '<div class="wmgn-card__row"><span>' + esc(r.name) + '</span>' + (showPrice && r.price ? '<span class="wmgn-card__price">' + esc(r.price) + '</span>' : '') + '</div>' +
      (r.veh ? '<div class="wmgn-cap wmgn-card__veh" style="padding-top:5px">' + esc(r.veh) + '</div>' : '<div class="wmgn-cap" style="padding-top:5px">' + esc(r.brand) + '</div>') + '</a>';
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-wmgn-more]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var sec = btn.closest('[data-wmg-native]'), grid = sec && sec.querySelector('.wmgn-products');
    if (!grid) return;
    var handle = btn.getAttribute('data-wmgn-more'), label = btn.textContent;
    var have = {}; [].slice.call(grid.querySelectorAll('[data-handle]')).forEach(function (a) { have[a.getAttribute('data-handle')] = 1; });
    var showPrice = btn.getAttribute('data-price') !== 'false', shape = btn.getAttribute('data-shape') || '1/1';
    btn.disabled = true; btn.textContent = 'Loading\u2026';
    var html = [];
    (function step(n) {
      return rowsPage(handle, n).then(function (j) {
        (j.rows || []).forEach(function (r) { if (r && r.handle && !have[r.handle]) { have[r.handle] = 1; html.push(card(r, showPrice, shape)); } });
        if (n < (Number(j.pages) || 1) && n < 100) return step(n + 1);
      });
    })(1).then(function () {
      grid.insertAdjacentHTML('beforeend', html.join(''));
      var box = btn.closest('.wmgn-more'); if (box) box.remove();
    }).catch(function () { btn.disabled = false; btn.textContent = label; });
  });
})();
